import { CSSProperties } from "react";
import styled from "styled-components";
import C from "@assets/themes/colors";

export const InputContainer: CSSProperties = {
  width: "300px",
}

export const InputName: CSSProperties = {
  color: C.DARK_BLUE,
  fontSize: "14px",
  height: "40px",
  padding: "0px 10px",
}

export const Button: CSSProperties = {
  width: "140px",
}

export const CancelButton = {
  ...Button,
  backgroundColor: "transparent", 
  border: `1px solid ${C.DARK_BLUE}`, 
  hoverBackgroundColor: `${C.DARK_BLUE}22`,
}

export const ConfirmButton = {
  ...Button,
  hoverBackgroundColor: `${C.DARK_BLUE}AA`,
}

export const LabelCancelButton: CSSProperties = {
  color: C.DARK_BLUE,
}

export const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.46);
  z-index: 200;
`;

export const Box = styled.div`
  width: 1000px;
  border-radius: 6px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  background-color: ${C.WHITE};
`;

export const Top = styled.div`
  display: flex;
  align-items: center;
  height: 96px;
  background-color: ${C.LIGHTEST_GRAY};
`;

export const Title = styled.span`
  padding: 0px 60px;
  font-size: 24px;
  font-weight: 500;
  color: ${C.BLACK};
`;

export const Content = styled.div`
  min-height: 200px;
  padding: 24px 60px;
  display: flex;
  flex-direction: column;
`;

export const Description = styled.span`
  margin-bottom: 35px;
  color: ${C.BLACK};
`;

export const InputTitle = styled.span`
  margin-bottom: 15px;
  font-size: 12px;
  color: ${C.DARK_BLUE};
`;

export const ActionsContainer = styled.div`
  padding: 50px 40px;
  display: flex;
  justify-content: flex-end;
`;

export const Actions = styled.div`
  display: flex;
  gap: 12px;
`;